module.exports = __webpack_public_path__ + "assets/img/member-search@3x.6e2fe16c.png";